// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qdfP7gzhFUDUdWmkcOp7{display:flex;flex-flow:column nowrap;row-gap:10px;width:100%}`, "",{"version":3,"sources":["webpack://./src/features/dashboard/views/DashboardView/view.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CAEA,uBAAA,CACA,YAAA,CAEA,UAAA","sourcesContent":[".main {\n  display: flex;\n\n  flex-flow: column nowrap;\n  row-gap: 10px;\n\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `qdfP7gzhFUDUdWmkcOp7`
};
export default ___CSS_LOADER_EXPORT___;
